import React from 'react';

const ContactUsDealer = (): JSX.Element =>
    // TODO: needs to be implemented
    <div>Some Content</div>;

export default ContactUsDealer;
